import React from "react";
import cn from "classnames";
import styles from "gui/poster/poster.module.css";
import { useRootClass } from "lib/hooks/use-root-class";

interface Props {
  className?: string;
}

export const Poster: React.FC<Props> = (props) => {
  const className = cn(styles.poster, props.className);
  useRootClass(styles.root);

  return (
    <div className={styles.pageCenter}>
      <div className={className}>{props.children}</div>
    </div>
  );
};

// MultiPoster allows you to seperate multiple card like components
// in the poster with gaps between each card
export const MultiPoster: React.FC<Props> = (props) => {
  const className = cn(styles["multi-poster"], props.className);
  useRootClass(styles.root);

  return (
    <div className={styles.pageCenter}>
      <div className={styles.itemsGrid}>
        {React.Children.toArray(props.children)
          // Dont show falsey elements like false, '""' or null
          .filter((c) => c)
          .map((child, i) => (
            <div key={i} className={className}>
              {child}
            </div>
          ))}
      </div>
    </div>
  );
};
